import { render } from "./ClientItem.vue?vue&type=template&id=8a9d9038"
import script from "./ClientItem.vue?vue&type=script&lang=js"
export * from "./ClientItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__